module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 13-9569f7f48fb7fcb4ffda3a7c3ecc974a.png";